import React, { useState, useEffect } from 'react'
import { getPermisosByUser } from '@auteco/services/sostenibilidadService'

import Tooltip from '../../components/snopComponents/Tooltip/Tooltip'

import './SostenibilidadIndicadorContainer.css'

const SostenibilidadIndicadorContainer = () => {
  const [permisos, setPermisos] = useState(0)

  const handleGetPermisosByUser = async () => {
    const response = await getPermisosByUser()
    if (response) {
      const indicadorPermiso = response.permisos.find(
        (permiso) => permiso.nombre === 'Indicadores',
      )
      if (indicadorPermiso) {
        setPermisos(parseInt(indicadorPermiso.alcance, 10))
      }
    }
  }

  useEffect(() => {
    handleGetPermisosByUser()
  }, [])

  if (permisos === 0) {
    return (
      <div>
        <p>Permisos insuficientes</p>
      </div>
    )
  }

  return (
    <>
      <p>{permisos}</p>
      <div className="tooltip-container" />
      <Tooltip
        text="Debes tener la
sesión de email
corporativo en
navegador"
      >
        <p className="int-button">?</p>
      </Tooltip>
      <iframe
        title="Fill Rate"
        width="100%"
        height="90%"
        src="https://app.powerbi.com/reportEmbed?reportId=54635f67-ab4f-474a-85ea-f7e519078934&autoAuth=true&ctid=1a8e863a-6a66-4905-990b-f7062b267787"
        frameBorder="0"
        allowFullScreen="true"
      />
    </>
  )
}

export default SostenibilidadIndicadorContainer
